export { default } from './MenuList';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/MenuList/index.js
// module id = 553
// module chunks = 2